import React from 'react';
import {
  BetNotificationWr,
  UnderMaintenanceWr,
  ConnectionPopupsWr,
  SlowConnectionWr,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { Game } from '../../common/game';
import { gameStore } from '../../../store';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../../../enums/additionalNotifications';

export const MobileGame = observer(() => {
  const { mobileGameScene } = gameStore;

  return (
    <div className={`mobile ${mobileGameScene ? 'hide' : ''}`}>
      <Game />
      <UnderMaintenanceWr />
      <ConnectionPopupsWr />
      <SlowConnectionWr />
      <BetNotificationWr
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
      />
    </div>
  );
});
